// extracted by mini-css-extract-plugin
export default {"Calendar":"PostingPlanCloneCalendar_Calendar__qRDbZ","AxisLabel":"PostingPlanCloneCalendar_AxisLabel__y27ZP"};